import React, { useEffect, useMemo, useState } from 'react'
import { createB2BAPI } from "../../../api/Interceptor";
import B2BButton from '../../common/B2BButton';
import { useLocation, useNavigate } from 'react-router-dom';
import { IconArrowLeft } from '@tabler/icons-react';
import moment from 'moment';
import B2BTableGrid from '../../common/B2BTableGrid';
import './LoyaltyPointDetails.css';



const LoyaltyPointDetails = () => {
    const navigate = useNavigate();
    const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });
    const [rowCount, setRowCount] = useState(5);
    const [searchValue, setSearchValue] = useState('');
    const [walletdetails, setWalletDetails] = useState({});
    const [incomingmoney, setIncomingMoney] = useState(true);
    const [customerWalletDetails, setCustomerWalletDetails] = useState({});
    const [activeTab, setActiveTab] = useState('Sales Return Details');
    const [isLoading, setIsLoading] = useState(false)
    const [isError, setIsError] = useState(false);
    const [profile, setProfile] = useState({})
    const [loyalty, setLoyalty] = useState({})
    const [loading, setLoading] = useState(false)
  

    const location = useLocation();

    useEffect(() => {
        getWalletDetails();
        getCustomerWalletDetails();
        featchProfile();
    }, [pagination, searchValue, incomingmoney])

    useEffect(() => {
        getCustomerWalletDetails();
        getWalletDetails();
    }, [profile, loyalty])
    const featchProfile = async () => {
        try {
            setLoading(true);
            const res = await B2B_API.get("customer/profile").json();
            await fetchLoyalty(res?.response?.loyaltyId)
            getCustomerWalletDetails(res?.response?.customerId)
            getWalletDetails(res?.response?.customerId)
            setProfile(res.response);
        } catch (error) {
            console.error("Error fetching recommended items:", error);
        } finally {
            setLoading(false);
        }
    }

    const fetchLoyalty = async (loyaltyId) => {
        try {
            setLoading(true);
            const res = await B2B_API.get(`loyalty/loyaltyId?loyaltyId=${loyaltyId}`).json();
            setLoyalty(res.response);
        } catch (error) {
            console.error("Error fetching recommended items:", error);
        } finally {
            setLoading(false);
        }
    }

    const getWalletDetails = async (id) => {
        if (profile?.customerId === (null || undefined)) {
            return
        }
        const res = await B2B_API.get(`loyalty/customerWallet?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&id=${profile?.customerId === undefined ? id : profile?.customerId}&incoming=${incomingmoney}`).json();
        const finalres = res?.response?.content;
        const audits = finalres?.[0]?.customerSwatchAudit || [];
        setWalletDetails(audits);

    }

    const getCustomerWalletDetails = async (id) => {
        if (profile?.customerId === (null || undefined)) {
            return
        }
        const res = await B2B_API.get(`loyalty/customerWalletDashboard?id=${profile?.customerId === undefined ? id : profile?.customerId}`).json();
        setCustomerWalletDetails(res.response)
    }


    const options = useMemo(() => [{
        title: 'Earned Points',
        value: customerWalletDetails?.totalWalletAmount?.toFixed(2) || 0
    },
    {
        title: 'Burned Points',
        value: customerWalletDetails?.totalAdjustedAmount?.toFixed(2) || 0
    }, {
        title: 'Closing Points',
        value: (Number(customerWalletDetails?.totalWalletAmount) - Number(customerWalletDetails?.totalAdjustedAmount)).toFixed(2) || 0
    }
    ], [customerWalletDetails])

    const columns = useMemo(() => [
  {
    header: 'S.No',
    accessorFn: (_, index) => index + 1,
    size: 120,
 
  },
  {
    header: 'Earned Date',
    accessorFn: (row) => moment(row.createdDate).format('DD-MM-YYYY'),
    size: 120,
 
  },
  {
    header: 'Loyalty Id',
    accessorKey: 'loyaltyId',
    size: 120,
 
  },
//   {
//     header: 'Dc No',
//     accessorKey: 'receiptNo',
//     size: 120,
  
//   },
  {
    header: 'Loyalty Points',
    accessorKey: 'amount',
    size: 120,
 
  },
  {
    header: 'From',
    accessorKey: 'fromLocation',
    size: 120,
  },
], []);


    const column = useMemo(() => [
        {
            header: 'S.No',
            accessorFn: (_, index) => index + 1,
            size: 120,
        
        },
        {
            header: 'Order No',
            accessorKey: 'orderNo',
            size: 120
        },
        // {
        //     header: 'DC No',
        //     accessorKey: 'receiptNo',
        //     size: 120
        // },

        {
            header: 'Loyalty Points',
            accessorKey: 'amount',
            size: 120
        },
        {
            header: 'From',
            accessorKey: 'fromLocation',
            size: 120
        },

    ], [])


    const ViewWalletDetails = () => {
        navigate(`/crm/loyalty/point-status`)
    }

    const handleTabClick = (tab) => {
        if (tab === 'Sales Return Details') {
            setIncomingMoney(true)
        } else {
            setIncomingMoney(false)
        }
        setActiveTab(tab);
    }

    return (
        <div className="loyalty-point-details">
            <div className="loyalty-container">
                <div className="loyalty-header">
                    Loyalty Details
                </div>
            </div>
            {/* <div className="loyalty-customer-info">
                <div style={{ display: 'flex', alignItems: 'baseline', fontSize: '14px', gap: '0.5rem' }}>
                    <h3>Customer Name :  </h3>
                    <span>
                        {profile?.companyName}
                    </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'baseline', fontSize: '14px', gap: '0.5rem' }}>
                    <h3>Customer Id :  </h3>
                    <span>
                        {profile?.customerId}
                    </span>
                </div>
                   <div style={{ display: 'flex', alignItems: 'baseline', fontSize: '14px', gap: '0.5rem' }}>
                        <h3>Date : </h3>
                    <span>
                   {moment().format('DD-MM-YYYY')}
                    </span>
                </div>
            
            </div> */}
            <div className="loyalty-summary-boxes">
                {options.map(s => (
                     <div
                        key={s.title}
                        style={{
                            padding: '10px',
                            color: 'black',
                            textAlign: 'center',
                            borderRadius: '10px',
                            border: '1px solid #8BC53F',
                            minWidth: '160px',
                        }}
                    >
                          <h4 style={{fontWeight: 'bold'}}>{s.title}</h4>
                        <h4>{s.value}</h4>
                    </div>
                ))}

            </div>
            <div className="loyalty-tabs">
                <B2BButton style={{ backgroundColor: activeTab === 'Sales Return Details' ? '#8BC53F' : 'lightgrey', color: 'black' }} disabled={activeTab === 'Sales Return Details' ? true : false} name='Loyalty Earned' onClick={() => handleTabClick('Sales Return Details')} />
                <B2BButton style={{ backgroundColor: activeTab === 'Adjusted Amt Details' ? '#8BC53F' : 'lightgrey', color: 'black' }} disabled={activeTab === 'Adjusted Amt Details' ? true : false} name='Loyalty Burned' onClick={() => handleTabClick('Adjusted Amt Details')} />
            </div>
            <B2BTableGrid
                columns={incomingmoney ? columns : column}
                data={walletdetails}
                enableTopToolbar={true}
                enableGlobalFilter={true}
                pagination={pagination}
                rowCount={rowCount}
                onPaginationChange={setPagination}
                enableFullScreenToggle={true}
                searchTerm={searchValue}
                globalFilter={searchValue}
            />

        </div>
    )
}

export default LoyaltyPointDetails